import { getDownloadURL, getStorage, ref } from "firebase/storage";

export const getDownloadUrl = (path: string) => {
  const storage = getStorage();
  const pathReference = ref(storage, path);
  return getDownloadURL(pathReference);
};
